import Suppliers from '../views/suppliers/Index.vue';
import { checkauth } from '../Helper';

// inserimento e modifica sono pagine: tornando indietro la lista riparte dal suo URL
const SupplierCreate = () => import('../views/suppliers/Create.vue');
const SupplierEdit = () => import('../views/suppliers/Edit.vue');

function auth(to, from, next) {
	checkauth().then(response => {
		if (response) {
			next();
		} else {
			next('/login');
		}
	});
}

export default [
	{
		path: '/suppliers',
		name: 'suppliers',
		component: Suppliers,
		beforeEnter: auth,
	},
	// prima di /suppliers/:id, altrimenti "new" verrebbe letto come un id
	{
		path: '/suppliers/new',
		name: 'supplier-new',
		component: SupplierCreate,
		beforeEnter: auth,
	},
	{
		path: '/suppliers/:id',
		name: 'supplier-edit',
		component: SupplierEdit,
		beforeEnter: auth,
	},
];
